<div class="py-20 bg-light">
  <div class="container mx-auto px-6 max-w-lg text-center">
    <div class="bg-white dark:bg-slate-800 p-8 rounded-xl shadow-lg dark:shadow-slate-900/50 border">

      <!-- État de chargement -->
      @if (isLoading) {
        <h2 class="text-2xl font-bold text-secondary">Vérification de votre compte...</h2>
        <p class="text-gray-600 dark:text-gray-400 mt-2">Veuillez patienter.</p>
      } @else {
        <!-- Erreur -->
        @if (errorMessage) {
          <div class="flex justify-center mb-4">
            <svg class="h-16 w-16 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h2 class="text-2xl font-bold text-secondary">Erreur de vérification</h2>
          <p class="text-red-600 dark:text-red-400 mt-2">{{ errorMessage }}</p>
          <p class="text-sm text-gray-500 dark:text-gray-400 mt-4">
            Le lien a peut-être expiré. Veuillez essayer de renvoyer l'e-mail depuis la page d'inscription.
          </p>
        } @else {
          <div class="flex justify-center mb-4">
            <svg class="h-16 w-16 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h2 class="text-2xl font-bold text-secondary">Compte Vérifié !</h2>
          <p class="text-gray-600 dark:text-gray-400 mt-2">Votre compte a été activé avec succès.</p>
          <a routerLink="/login" [queryParams]="{ verified: 'true' }"
            class="mt-6 inline-block bg-primary text-white font-semibold px-6 py-3 rounded-lg hover:bg-primary-hover">
            Aller à la page de connexion
          </a>
        }
        <!-- Succès -->
      }

      <!-- État après chargement -->

    </div>
  </div>
</div>
